import { getBackendUrl } from "../config";

function apiUrl(path) {
  const backendUrl = getBackendUrl();
  if (!backendUrl) return "";
  return `${backendUrl}${path}`;
}

export function sendAnalyticsEvent(payload) {
  const url = apiUrl("/api/analytics/events");
  if (!url) return;
  const body = JSON.stringify(payload);
  try {
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
      mode: "cors",
    }).catch(() => {});
  } catch {
    // tracking must never break the site
  }
}
